import Aos from "aos";
import 'slick-carousel';

jQuery( document ).ready(function($) {
    $('.search-toggle').on('click', function(e){
        $('.search-wrapper').toggleClass('open');
        $('#header .menu').removeClass('open');
    })
    $('.menu-toggle').on('click', function(e){
        $('#header .menu').toggleClass('open');
        $('.search-wrapper').removeClass('open');
    })

    // SOCIAL WIDGET TABS
    $('.social-widget .tab').on('click', function (e) {
        e.preventDefault();
        $('.social-widget .tab, .social-widget .view').removeClass('active');
        $(this).addClass('active');
        const viewId = $(this).attr('href');
        $(viewId).addClass('active');
    });

    $('.Carousel').slick({
        slidesToShow: 3,
        variableWidth: true,
        centerMode: true,
        initialSlide: 1,
        arrows: true,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous"><i class="fal fa-chevron-circle-left"></i></button>',
        nextArrow:'<button type="button" class="slick-next" aria-label="Next"><i class="fal fa-chevron-circle-right"></i></button>',
    })


    Aos.init();
});